export const FilterFieldType = {
  TEXT: 'text',
  DROPDOWN: 'dropdown',
  TOGGLE: 'toggle',
  DATE: 'date',
};
